export default __webpack_public_path__ + "static/media/bumpFundHeroMobile.433f62ef.png";